import axios from "axios";
window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Echo & Pusher Configuration for Real-time
 */
import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: "pusher",
    key: "86cc9b802e69addb526a", // المفتاح الصريح الخاص بك
    cluster: "eu", // الكلاستر الصريح الخاص بك
    forceTLS: true,
});
